/**
@ngdoc directive
@name sidebarToggle

@description
Sidebar toggle for mobile version.
*/
(function() {
    'use strict';

    var sidebarToggle = function ($compile) {
        return {
            restrict: 'E',
            replace: false,
            link: function (scope, elem, attrs) {

                if(attrs['class'].indexOf('sidebar') > -1) { // contains 'sidebar' (for sidebar only) // TODO: be explicit, so it won't pick up sidebar-something
                    elem.after( $compile([
                        '<a id="sidebar-toggle" href="javascript:void(0);" ng-click="toggleSidebar();">',
                            '<div>',
                                '<span></span>',
                                '<span></span>',
                                '<span></span>',
                                '<span></span>',
                            '</div>',
                        '</a>'].join("") )(scope) );
                    scope.toggleSidebar = function(){
                        $('html').toggleClass('canvas-in'); // a little bit of jquery as html is out of ng-app at the moment
                    }
                }
            }
        };
    }

    sidebarToggle.$inject = ['$compile'];
    angular.module('app').directive('aside', sidebarToggle);

}());